module.exports = __webpack_public_path__ + "img/PRCA1_NK.3db95a11.png";